
import { defineComponent, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import type { VisitPageData } from './index';

export default defineComponent({
  name: 'VisitPageForm',

  components: {
    Button,
    InputText,
  },

  props: {
    modelValue: {
      type: Object as PropType<VisitPageData>,
      default: () => ({
        custom_title: '',
        custom_description: '',
        trigger_location: 1,
      }),
    },
    formValidation: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue', 'cancel', 'close', 'submit'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const localData = ref<VisitPageData>({ ...props.modelValue });

    const locationOptions = [
      {
        value: 1,
        label: t('flows.operators.visitPage.allPages'),
        description: t('flows.operators.visitPage.allPagesDesc'),
        icon: 'far fa-globe',
      },
      {
        value: 0,
        label: t('flows.operators.visitPage.specificPages'),
        description: t('flows.operators.visitPage.specificPagesDesc'),
        icon: 'far fa-filter',
      },
    ];

    watch(localData, (newData) => {
      emit('update:modelValue', newData);
    }, { deep: true });

    watch(() => props.modelValue, (newValue) => {
      if (newValue !== localData.value) {
        localData.value = { ...newValue };
      }
    });

    return {
      t,
      localData,
      locationOptions,
    };
  },
});
